import { useContext, useState } from "react";
import cx from "classnames";
import Button from "components/CustomButtons/Button";
import SettingsIcon from "@mui/icons-material/Settings";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import styles from "assets/jss/default/components/adminNavbarLinksStyle.js";
import makeStyles from "@mui/styles/makeStyles";
import { CognitoAuthContext } from "components/Authentication/CognitoAuthContext";
import { useLocation } from "react-router";
import CurrentUserAvatar from "components/CurrentUserAvatar/CurrentUserAvatar";

const useStyles = makeStyles(styles);

export default function DashNavLinks() {
  const [anchorEl, setAnchorEl] = useState(null);
  const { logout } = useContext(CognitoAuthContext);

  const location = useLocation();
  const classes = useStyles();
  const wrapper = cx({
    [classes.wrapperRTL]: false
  });

  const dashboardRelatedButtonsRequired =
    location.pathname.indexOf("/dashboard/") > -1 ||
    location.pathname.indexOf("/dashboard/new") > -1;

  const openProfileMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const closeProfileMenu = () => {
    setAnchorEl(null);
  };

  const onLogout = () => {
    logout();
  };

  return (
    <div className={wrapper}>
      {dashboardRelatedButtonsRequired && (
        <>
          <Button
            color="transparent"
            simple
            aria-label="Settings"
            justIcon
            className={classes.buttonLink}
            muiClasses={{
              label: ""
            }}
          >
            <SettingsIcon
              className={`${classes.headerLinksSvg} ${classes.links}`}
            />
          </Button>
        </>
      )}
      <Button
        color="transparent"
        simple
        aria-label="profile"
        justIcon
        className={classes.buttonLink}
        muiClasses={{
          label: ""
        }}
        onClick={openProfileMenu}
      >
        <CurrentUserAvatar />
      </Button>
      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        transformOrigin={{ horizontal: "center", vertical: "top" }}
        open={Boolean(anchorEl)}
        onClose={closeProfileMenu}
      >
        <MenuItem onClick={onLogout}>Logout</MenuItem>
      </Menu>
    </div>
  );
}
